import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseFirestoreService } from './base-firestore.service';
import { SMUser } from 'src/app/models/SMUser';
import { AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  COLLECTION_NAME = 'Users';
  private user: SMUser;
  private userData = new BehaviorSubject(null);
  private oUser: Observable<SMUser> = this.userData.asObservable();
  private userIDdata = new BehaviorSubject(null);
  private userID: Observable<any> = this.userIDdata.asObservable();
  private userDocRef: AngularFirestoreDocument<any>;

  constructor(private base: BaseFirestoreService) {
  }

  getUserID(): Observable<any> {
    return this.userID;
  }

  updateUserID(id: any) {
    this.userIDdata.next(id);
    this.userDocRef = this.base.getDocRef(this.userIDdata.value, this.COLLECTION_NAME);
  }

  getUserDocRef(): AngularFirestoreDocument<any> {
    return this.userDocRef;
  }

  getUserAsObservable(): Observable<SMUser> {
    return this.oUser;
  }

  async getUser(): Promise<SMUser> {
    if (!this.user) {
      this.user = await this.getUserFromFirebase();
      this.userData.next(this.user);
    }
    return this.user;
  }

  setUser(user: any) {
    this.user = user;
  }

  private async getUserFromFirebase(): Promise<SMUser> {
    const docRef = this.base.getDocRef(this.userIDdata.value, this.COLLECTION_NAME);
    const doc = await this.base.getDoc(docRef);
    if (doc.exists) {
      const data: SMUser = Object.assign(doc.data());
      return data;
    }
    return null;
  }

  async updateUser(user: SMUser): Promise<boolean> {
    const result = await this.base.updateRecord(this.userIDdata.value, user, this.COLLECTION_NAME);
    if (result) {
      this.userData.next(user);
      this.setUser(user);
    }
    return result;
  }

  async getUsers(refData: string, refStr: string): Promise< Observable < any[]> > {
    return this.base.getFirestore().collection(this.COLLECTION_NAME, ref => {
      return ref.where( refStr, '==', refData);
    }).valueChanges({ idField: 'id' });
  }
}
